import { render } from "./FormCreateCourse.vue?vue&type=template&id=01904d74&scoped=true"
import script from "./FormCreateCourse.vue?vue&type=script&lang=js"
export * from "./FormCreateCourse.vue?vue&type=script&lang=js"

import "./FormCreateCourse.vue?vue&type=style&index=0&id=01904d74&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01904d74"]])

export default __exports__